<template>
  <div class="flex-column d-flex">
    <v-card rounded="0" width="100%" elevation="0" class="quiz-card">
      <Typography as="p" variant="h-5" class="quiz-question__title mb-0">
        {{ question.content }}{{ !isRequired ? " (optional)" : "" }}
      </Typography>
      <Typography as="p" variant="body-2" class="pt-5 quiz-question__helper mb-0">
        Choose a response from the answers below
      </Typography>
      <v-divider class="mt-5" />

      <v-radio-group
        row
        v-model="value"
        class="full-width justify-space-between py-2"
        :class="isMobile ? '' : 'px-4'"
      >
        <div class="d-flex flex-column align-center text-center px-2 likert-button">
          <v-radio color="red" class="strongly-disagree" value="stronglyDisagree"> </v-radio>
          <div class="mt-1 quiz-question__likert-label">
            Strongly<br />
            Disagree
          </div>
        </div>
        <div class="d-flex flex-column align-center text-center px-2 likert-button">
          <v-radio color="orange lighten-1" class="disagree" value="disagree"> </v-radio>
          <div class="mt-1 quiz-question__likert-label">Disagree</div>
        </div>
        <div class="d-flex flex-column align-center text-center px-2 likert-button">
          <v-radio color="yellow darken-1" class="neutral" value="neutral"> </v-radio>
          <div class="mt-1 quiz-question__likert-label">Neutral</div>
        </div>
        <div class="d-flex flex-column align-center text-center px-2 likert-button">
          <v-radio color="#BFE078" class="agree" value="agree"> </v-radio>
          <div class="mt-1 quiz-question__likert-label">Agree</div>
        </div>
        <div class="d-flex flex-column justify-center align-center text-center px-2 likert-button">
          <v-radio color="green" class="strongly-agree" value="stronglyAgree"> </v-radio>
          <div class="mt-1 quiz-question__likert-label">Strongly<br />Agree</div>
        </div>
      </v-radio-group>

      <v-divider />
      <div class="d-flex justify-center mt-10">
        <v-btn
          :color="!inProgram ? 'brandPrimary' : 'brand'"
          :rounded="!inProgram"
          class="white--text"
          depressed
          @click="checkQuestion"
          :disabled="isMissingRequiredValue(value)"
          width="120"
          :loading="postingResponse"
        >
          {{ computedSubmitButton }}
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import quizQuestionResponseMixin from "@/components/learning/QuizQuestion/mixins/quizQuestionResponseMixin";
import isMobileMixin from "@/mixins/isMobile";

export default {
  name: "QuizQuestionLikertV2",
  mixins: [quizQuestionResponseMixin, isMobileMixin],
  components: { Typography },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    checkQuestion() {
      if (this.skipOptionalUnanswered(this.value, { onSuccess: this.handleSuccess })) {
        return;
      }

      const quizQuestionResponse = this.buildBaseResponse({
        value: this.value,
      });

      this.postResponseAndAdvance([quizQuestionResponse], {
        onSuccess: this.handleSuccess,
        onError: this.handleError,
      });
    },
    handleSuccess() {
      this.goToNextQuestion();
    },
    handleError() {},
    goToNextQuestion() {
      if (!this.isLastQuestion) {
        this.value = null;
        this.$emit("next-question", true);
      } else {
        this.completeQuiz();
      }
    },
    completeQuiz() {
      this.$emit("complete-quiz", true);
    },
  },
};
</script>

<style scoped>
/* Figma: question = Headline/h5, helper = Body/Body 2, labels = Body/Body 1 */
.quiz-question__title {
  color: rgba(0, 0, 0, 0.87);
  word-break: normal;
}

.quiz-question__helper {
  color: rgba(0, 0, 0, 0.6);
}

.quiz-question__likert-label {
  font-family: "Avenir Book", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(0, 0, 0, 0.87);
}

@media only screen and (max-width: 600px) {
  .quiz-question__likert-label {
    font-size: 12px;
  }
}

/* Classes for formatting radio buttons with different colors */
.strongly-disagree >>> .v-icon {
  color: red;
  border-color: red;
}
.strongly-disagree {
  display: flex;
  justify-content: center !important;
}
.strongly-disagree >>> .v-input--selection-controls__input {
  margin: 0px;
}

.v-radio.strongly-disagree.theme--light {
  margin: 0px;
}

.disagree >>> .v-icon {
  color: #ffa726;
  border-color: #ffa726;
}
.v-radio.disagree.theme--light {
  margin: 0px;
}
.disagree >>> .v-input--selection-controls__input {
  margin: 0px;
}

.neutral >>> .v-icon {
  color: #ffd54f;
  border-color: #ffd54f;
}
.v-radio.neutral.theme--light {
  margin: 0px;
}
.neutral >>> .v-input--selection-controls__input {
  margin: 0px;
}

.agree >>> .v-icon {
  color: #bfe078;
  border-color: #bfe078;
}
.v-radio.agree.theme--light {
  margin: 0px;
}
.agree >>> .v-input--selection-controls__input {
  margin: 0px;
}

.strongly-agree >>> .v-icon {
  color: #4caf50;
  border-color: #4caf50;
}
.v-radio.strong-agree.theme--light {
  margin: 0px;
}
.strongly-agree >>> .v-input--selection-controls__input {
  margin: 0px;
  margin-left: 16px !important;
}

/* Spacing for each likert button */
.likert-button {
  width: 20%;
}
</style>
